/* global fetch */

import querystring from 'querystring';
import { config } from '../config';
import { headers, APIResponse, stleaf, fetchAPI, SpanTag } from '../helpers';

interface GetUserActionsOptions {
  start?: number;
}

export const getUserActions = (
  st: SpanTag,
  options: GetUserActionsOptions = {}
): Promise<APIResponse> => {
  const { start = 0 } = options;

  const queryString = querystring.stringify({ start });
  const query = queryString ? `?${queryString}` : '';

  return fetchAPI(
    stleaf(st, 'na0een'),
    `${config.API_URL}/v1/user-actions${query}`,
    {
      method: 'GET',
      credentials: 'include',
      headers,
    }
  );
};

export const postUserUploadAction = (
  st: SpanTag,
  mapId: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/user-actions/upload/${mapId}`;
  return fetchAPI(stleaf(st, 'loash6'), url, {
    method: 'POST',
    credentials: 'include',
    headers,
  });
};

export const postMapViewAction = (
  st: SpanTag,
  mapId: string,
): Promise<APIResponse> => {
  const url = `${config.API_URL}/v1/user-actions/view/${mapId}`;
  return fetchAPI(stleaf(st, 'ieh9ei'), url, {
    method: 'POST',
    credentials: 'include',
    headers,
  });
};
